<template>
  <div class="storyblok-teaser-departments-scroll-horizontal is-medium-wide" :style="`--amount-of-items: ${items.length};`">
    <div
      ref="scrollWrapperRef"
      class="storyblok-teaser-departments-scroll-horizontal__wrapper"
    >
      <div
        class="storyblok-teaser-departments-scroll-horizontal__inner-wrapper"
      >
        <div class="storyblok-teaser-departments-scroll-horizontal__inner-wrapper-inner-wrapper">
          <UtilWrapperLayout>
            <div ref="scrollContentRef" class="storyblok-teaser-departments-scroll-horizontal__inner-wrapper-inner">
              <div
                v-for="item in items"
                :key="item._uid"
                ref="cardRefs"
                class="storyblok-teaser-departments-scroll-horizontal__card"
              >
                <BlockItemCardScroll
                  :image="item.image"
                  :title="item.title"
                  :lead="item.lead"
                  :text="item.text"
                  :link="item.link"
                  :link-label="item.linkLabel"
                  :color="item.color"
                  class="storyblok-teaser-departments-scroll-horizontal__popup-card"
                />
              </div>
            </div>
          </UtilWrapperLayout>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
    items: {
        type: Array,
        required: true,
        default: () => [],
        validator: (value) => value.length > 0,
    },
});
const scrollWrapperRef = ref(null);
const scrollContentRef = ref(null);
const cardRefs = ref([]);

onMounted(() => {
    watch(() => cardRefs.value, (newValue) => {
        if (isArrayNotEmpty(newValue)) {
            cardRefs.value.forEach((card) => {
                GSAP.to(card, {
                    scale: 1,
                    translateX: 0,
                    scrollTrigger: {
                        trigger: card,
                        start: 'top 80%',
                        end: '+=70%',
                        scrub: true,
                    },
                });
            });
        }
    }, {
        immediate: true,
    });
});
</script>

<style lang="scss" scoped>
.storyblok-teaser-departments-scroll-horizontal {
    @include fluid('margin-bottom', 50px, 180px);
    @include fluid('--negative-margin', 0px, 150px);
    position: relative;
    margin-top: calc(var(--negative-margin) * -1);

    @include mobile {
        margin-top: 0;
    }
}

.storyblok-teaser-departments-scroll-horizontal__wrapper {
    @include default-content-columns;
    position: relative;
    display: flex;
    width: 100%;
    max-width: 100%;
    height: calc(var(--amount-of-items) * 75vh);
    flex-direction: row;

    @include mobile {
        height: min-content;
    }
}

.storyblok-teaser-departments-scroll-horizontal__inner-wrapper {
    position: sticky;
    top: 0;
    display: flex;
    width: 100%;
    height: 100vh;
    flex-direction: row;
    align-items: center;
    gap: 0;
    transform-style: preserve-3d;
    will-change: transform;

    @include mobile {
        position: relative;
        top: 0;
        overflow: hidden;
        height: auto;
    }
}

.storyblok-teaser-departments-scroll-horizontal__inner-wrapper-inner {
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: row;
    gap: 10px;
    will-change: transform;

    @include mobile {
        flex-direction: column;
    }
}

.storyblok-teaser-departments-scroll-horizontal__card {
    position: relative;
    overflow: hidden;
    max-width: 33%;
    flex-basis: 33%;
    flex-grow: 0;
    flex-shrink: 0;
    transform: translateX(100vw) scale(0.5);
    transform-origin: center right;

    @include mobile {
        max-width: 100%;
        flex-basis: 100%;
        transform: translateX(100vw) scale(1);
    }
}

.storyblok-teaser-departments-scroll-horizontal__image {
    height: 320px;
}

.storyblok-teaser-departments-scroll-horizontal__heading {
    padding: 40px 40px 67px 40px;
    color: var(--c-petrol-1);
}

.storyblok-teaser-departments-scroll-horizontal__title {
    font-family: var(--f-family--black);
    font-size: var(--f-size--h3);
    line-height: var(--l-height--h3);
}

.storyblok-teaser-departments-scroll-horizontal__lead {
    max-width: 345px;
    font-family: var(--f-family--regular);
    font-size: var(--f-size--h4);
    line-height: var(--l-height--h4);
}

.storyblok-teaser-departments-scroll-horizontal__mobile-cards {
    @include fluid('margin-bottom', 70px, 80px);

    display: none;
    flex-wrap: wrap;
    gap: 20px;

    @include tablet {
        display: flex;
    }
}
.storyblok-teaser-departments-scroll-horizontal__inner-wrapper-inner-wrapper {
    overflow: hidden;
    width: 100%;
}
</style>
